import React from 'react';

const TagIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M17.1582 11.175L11.1832 17.15C11.0284 17.305 10.8446 17.4279 10.6422 17.5118C10.4399 17.5956 10.223 17.6388 10.004 17.6388C9.78498 17.6388 9.5681 17.5956 9.36577 17.5118C9.16344 17.4279 8.97963 17.305 8.82484 17.15L1.6665 10V1.66667H9.99984L17.1582 8.82501C17.4686 9.13728 17.6428 9.5597 17.6428 10C17.6428 10.4403 17.4686 10.8627 17.1582 11.175V11.175Z"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M5.8335 5.83333H5.84183" stroke="#ABABAB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default TagIcon;
